import { render } from "./DashboardController.vue?vue&type=template&id=78a115e1"
import script from "./DashboardController.vue?vue&type=script&lang=js"
export * from "./DashboardController.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__